export type WebSafeAreaInsets = {
  top: number
  right: number
  bottom: number
  left: number
}

function readCssPx(property: string): number {
  if (typeof document === 'undefined') return 0

  const raw = getComputedStyle(document.documentElement).getPropertyValue(property).trim()

  if (!raw || raw.includes('env(') || raw.includes('constant(')) return 0

  const parsed = Number.parseFloat(raw)
  return Number.isFinite(parsed) ? parsed : 0
}

function readEnvPx(property: string): number {
  if (typeof document === 'undefined') return 0

  const probe = document.createElement('div')

  probe.style.position = 'fixed'
  probe.style.visibility = 'hidden'
  probe.style.pointerEvents = 'none'
  probe.style.paddingTop = `env(${property}, 0px)`

  const parent = document.body ?? document.documentElement
  parent.appendChild(probe)

  const raw = getComputedStyle(probe).paddingTop
  probe.remove()

  const parsed = Number.parseFloat(raw)

  return Number.isFinite(parsed) ? parsed : 0
}

function readSafeAreaPx(cssProperty: string, envProperty: string): number {
  return readCssPx(cssProperty) || readEnvPx(envProperty)
}

export function readWebSafeAreaInsets(): WebSafeAreaInsets {
  return {
    top: readSafeAreaPx('--safe-area-inset-top', 'safe-area-inset-top'),
    right: readSafeAreaPx('--safe-area-inset-right', 'safe-area-inset-right'),
    bottom: readSafeAreaPx('--safe-area-inset-bottom', 'safe-area-inset-bottom'),
    left: readSafeAreaPx('--safe-area-inset-left', 'safe-area-inset-left'),
  }
}

// Только env(), без наших override --safe-area-inset-*. Иначе следующий sync
// читает уже записанный chrome и больше не отпускает его (клавиатура, поворот).
export function readWebEnvSafeAreaInsets(): WebSafeAreaInsets {
  return {
    top: readEnvPx('safe-area-inset-top'),
    right: readEnvPx('safe-area-inset-right'),
    bottom: readEnvPx('safe-area-inset-bottom'),
    left: readEnvPx('safe-area-inset-left'),
  }
}

export function toSafeAreaMetrics(insets: WebSafeAreaInsets) {
  const height = typeof window !== 'undefined' ? window.innerHeight : 0
  const width = typeof window !== 'undefined' ? window.innerWidth : 0

  return {
    frame: { x: 0, y: 0, width, height },
    insets,
  }
}
